import { render, staticRenderFns } from "./TermInfoForm.vue?vue&type=template&id=1bd9262c&"
import script from "./TermInfoForm.vue?vue&type=script&lang=js&"
export * from "./TermInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports